var domainIP = "https://web.vimass.vn/";
// var domainIP ="http://118.69.84.243:28080/"


// eslint-disable-next-line no-unused-vars
let ROOT = "https://vimass.vn/";

export const KEY_USER = "keyúser";
export const KEY_MA_DN = "keyLuuMaDN";
export const KEY_EMAIL_LOGIN = "keyLuuWallLogin";
export const KEY_NAME_LOGIN = "keyLuuTenLogin";
export const KEY_SESSION_ID = "keySessionId";
export const KEY_PHONE_ID = "keyDungLuuSoDienThoai";


export const SERVICE_DANGNHAP_VID = domainIP + "vmbank/services/account/login1";
export const apiChiTietBaiViet = domainIP + "vmbank/services/quangCaoUuDai/getDetail";
export const apiChiTietBaiVietVer2 = domainIP + "vmbank/services/quangCaoUuDai/getDetailVer2";
export const apiLayChiTietDanhMuc = domainIP + "vmbank/services/categoryAdv/getDetailVer2";
export const apiThongKeVpass = "http://113.190.248.142:58080/autobank/services/vimassTool/dpTuVer2";
export const service_laydanhmuc = domainIP + "/vmbank/services/categoryAdv/getList";
export const service_laydanhsachBaiViet = domainIP + "vmbank/services/quangCaoUuDai/getList";
export const service_DanhMuc = domainIP + "vmbank/services/quangCaoUuDai/";
export const service_BaiViet = domainIP + "vmbank/services/quangCaoUuDai/";



